import React from 'react';

function TestComponent() {
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h1>Router Test Component</h1>
      <p>If you can see this, the router is working correctly!</p>
    </div>
  );
}

export default TestComponent;